import { h, Component } from 'preact';
import cx from 'classnames';
import { Listing } from '../../../../../types/listing.model';
import { ReqState } from '../../../../../types/request-state.model';

import { InquiryClientInfo } from '../shared/inquiry-client-info.component';
import { InquiryDetailsFTF } from './inquiry-details-ftf';
import { InquiryDetailsIcon } from '../shared/inquiry-details-icon';
import {
  Inquiry,
  InquiryUploader,
  InquiryFTF
} from 'inquiries/inquiry.model';
import { Comment } from 'comment.model';
import moment from 'moment-timezone';
import { ContactUploaderModal } from './inquiry-contact-uploader';
import { InquiryDetailsDocumentList } from './inquiry-details-document-list.component';
import { InquiryDocument } from 'inquiries/inquiry-document.model';
import { ViewingListMetadata } from '../../../../../types/inquiries';
import { InquiryDocumentType }  from '../../../../../constants/inquiries';
import { InquiryDetailsVlList } from './inquiry-details-vl-list.component';
import { ListResponse } from '../../../../../types';

import { InquiryDetailsPropertyList } from './inquiry-details-property-list.component';

enum CollapsingSection { 'FTF', 'SELECTED_PROPERTIES' }

interface InquiryDetailsCardProps {
  mobileMode?: boolean;
  inquiry: Inquiry;

  ftf: InquiryFTF;
  comments: ListResponse<Comment>;
  selectedProperties: ListResponse<Listing>;
  viewingLists: ListResponse<ViewingListMetadata>;
  offers: ListResponse<InquiryDocument>;
  contracts: ListResponse<InquiryDocument>;

  ftfReqState: ReqState;
  commentsReqState: ReqState;
  selectedPropertiesReqState: ReqState;
  viewingListReqState: ReqState;
  offersReqState: ReqState;
  contractsReqState: ReqState;

  onEditFTF: (inquiry: Inquiry, ftf: InquiryFTF) => void;
  onCreateVl?: (inquiry: Inquiry) => void;
  onEditVl: (inquiry: Inquiry, vlKey: string) => void;
  onCreateLoiClick: (inquiry: Inquiry) => void;
  onEditLoiClick: (inquiry: Inquiry, documentItem: InquiryDocument) => void;
  onEditCommissionClick: (inquiry: Inquiry) => void;
  onUploadOfferSentClick: (inquiry: Inquiry) => void;

  onUploadOfferGenericClick: (inquiry: Inquiry) => void;
  onSentOfferStatusClick: (inquiry: Inquiry, documentItem: InquiryDocument) => void;

  onCreateContractClick: (inquiry: Inquiry) => void;
  onEditContractClick: (inquiry: Inquiry, documentItem: InquiryDocument) => void;
  onUploadContractClick: (inquiry: Inquiry) => void;

  onShowCommentsModal: (inquiry: Inquiry) => void;

  onClose?: () => void;
}

interface InquiryDetailsCardState {
  activeCollapse?: CollapsingSection;
  loiUploadModalVisible?: boolean;
  loiCreateModalVisible?: boolean;

  isFetching?: ReqState;
  isGettingComments?: ReqState;
  isShowingAllComments?: boolean;

  // inquiryFTF: InquiryFTF;
  inquiryCode?: string;

  uploaderModalVisible?: boolean;
  inquiryUploader?: InquiryUploader;
}

export class InquiryDetailsCard extends Component<InquiryDetailsCardProps, InquiryDetailsCardState> {
  constructor(props) {
    super(props);

    this.state = {
      activeCollapse: null,
      isFetching: null,
      loiUploadModalVisible: false,
      loiCreateModalVisible: false,
      isShowingAllComments: false,
    }
  }

  componentWillReceiveProps(nextProps: InquiryDetailsCardProps) {
    const curInquiry = this.props.inquiry;
    const nextInquiry = nextProps.inquiry;

    if (nextInquiry) {
      // Prevent unnecessary retrieval of the same inquiry
      if (!curInquiry || curInquiry.inquiryCode !== nextInquiry.inquiryCode) {
        this.setState({ activeCollapse: null });
      }
    }
  }

  showUploaderModal = (uploader: InquiryUploader) => {
    this.setState({
      inquiryUploader: uploader,
      uploaderModalVisible: true
    })
  }

  hideUploaderModal = () => {
    this.setState({ uploaderModalVisible: false })
  }

  toggleShowMore = () => {
    this.setState({
      isShowingAllComments: !this.state.isShowingAllComments
    })
  }

  defineCommentCount(): Comment[] {
    if (this.props.commentsReqState !== ReqState.SUCCESS) {
      return [];
    }
    const comments = this.props.comments || {};

    if (this.state.isShowingAllComments) 
      return comments.results;
    return comments.results;
  }

  onShowCommentsModal() {
    this.props.onShowCommentsModal(this.props.inquiry);
  }

  getCollapseLabel(label: string, section: CollapsingSection) {
    return (
      <div
        onClick={ () => this.onSectionClicked(section) } 
        className="hi-inqdetails__collapse-label">
        <p className="mb-0">{ label }</p>
        <i className={ cx("fas text-muted", {
          'fa-angle-down': this.state.activeCollapse != section,
          'fa-angle-up': this.state.activeCollapse == section
        }) }></i>
      </div>
    )
  }

  getMobileContactBar() {
    const client = this.props.inquiry.client;

    return (
      <div className="hi-inqdetails__header-contact-bar">
        <a 
          href={ `tel:${client.mobile}` }
          className="btn btn-default contact-btn">
          <InquiryDetailsIcon 
            icon="mobile"
            hasMargin={ false }
            fontSize={ 18 }
          />
        </a>

        <a 
          href={ `sms:${client.mobile}` }
          className="btn btn-default contact-btn">
          <InquiryDetailsIcon 
            icon="comment"
            hasMargin={ false }
            fontSize={ 18 }
          />
        </a>

        <a 
          href={ `mailto:${client.email}` }
          className="btn btn-default contact-btn">
          <InquiryDetailsIcon 
            icon="email"
            hasMargin={ false }
            fontSize={ 18 }
          />
        </a>
      </div>
    )
  }

  getCommentsBlock(props: InquiryDetailsCardProps, state: InquiryDetailsCardState) {
    if (props.commentsReqState == ReqState.SUCCESS) {
      if (props.comments.count > 0) {
        const commentsToShow = props.comments.results.slice(0, 3);

        return (
          <div className="hi-inqdetails__comments">
            {
              commentsToShow.map(comment => (
                <div className="hi-inqdetails__comments-item">
                  <p className="mb-0">
                    <span className="font-weight-bold">{ comment.fullName }</span>
                    <span className="text-muted"> - </span>
                    <span className="text-muted">{ moment(comment.dateCreated).format('YYYY/MM/DD') }</span>
                  </p>
                  <span>{ comment.comment }</span>
                </div>
              ))
            }
          </div>
        );
      } else {
        return (
          <div className="hi-inqdetails__activity-row mt-4">
            <p className="mb-0 ">No comments/activities</p>
          </div>
        )
      }
    }
  }

  getCommentsSeeMoreButton(props: InquiryDetailsCardProps, state: InquiryDetailsCardState) {
    const { comments, commentsReqState } = props;

    if (commentsReqState === ReqState.SUCCESS && comments.count > 3) {
      return (
        <div className="text-right">
          <button onClick={ () => this.onShowCommentsModal() } 
            className="btn btn-link">
            See more
          </button>
        </div>
      );
    }
  }

  getCommentsSpinnerIndicator(props: InquiryDetailsCardProps, state: InquiryDetailsCardState) {
    if (props.commentsReqState == ReqState.IN_PROGRESS) {
      return (
        <div className="ml-2 spinner-border spinner-border-sm" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      )
    }
  }


  onSectionClicked = (section: CollapsingSection) => {
    if (this.state.activeCollapse == section) {
      this.setState({ activeCollapse: null })
    } else {
      this.setState({ activeCollapse : section })
    }
  }

  toggleLoiUploadModal = () => {
    this.setState({ 
      loiUploadModalVisible: !this.state.loiUploadModalVisible
    })
  }

  toggleLoiCreateModal = () => {
    this.setState({ 
      loiCreateModalVisible: !this.state.loiCreateModalVisible
    })
  }

  render(props: InquiryDetailsCardProps, state: InquiryDetailsCardState) {
    const { activeCollapse } = this.state;
    let showCommissionEdit = false;
    if (props.inquiry.collected === undefined || props.inquiry.collected === 0)  {
      showCommissionEdit = true
    }

    return (
      <section className={ cx("hi-inqdetails", { 'hi-inqdetails__modal-mode': props.mobileMode }) }>
        { state.uploaderModalVisible ? 
          <ContactUploaderModal
            onClose={ this.hideUploaderModal }
            uploader={ state.inquiryUploader }/> : null }
        
        <div className="hi-inqdetails__header">
          <InquiryClientInfo
            centered={ true }
            inquiry={ props.inquiry }
            forceDefaultStyling={ true } />

          { this.getMobileContactBar() }

          <button
            onClick={ props.onClose }
            className="btn hi-inqdetails__header-arrow-btn">
            <i className="fas fa-arrow-left"></i>
          </button>

          <button className="btn hi-inqdetails__header-dropdown-btn">
            <i className="far fa-caret-square-down"></i>
          </button>
        </div>

        <div className="hi-inqdetails__body">
          <div className="hi-inqdetails__collapse">
            { this.getCollapseLabel('Inquiry details (FTF)', CollapsingSection.FTF) }

            <div className={ cx("hi-inqdetails__collapse-wrapper", {
              'collapse show': activeCollapse == CollapsingSection.FTF })}>
              <InquiryDetailsFTF
                inquiryFTF={ props.ftf }
                inquiry={ props.inquiry }
                ftfReqState={ props.ftfReqState }
                onEditClick={ () => props.onEditFTF(props.inquiry, props.ftf) } />
            </div>
          </div>

          <div className="hi-inqdetails__collapse">
            { this.getCollapseLabel('Selected properties', CollapsingSection.SELECTED_PROPERTIES) }
          
            <div className={ cx("hi-inqdetails__collapse-wrapper", {
              'collapse show': activeCollapse == CollapsingSection.SELECTED_PROPERTIES })}>
              <InquiryDetailsPropertyList listings={ props.selectedProperties }
                reqState={ props.selectedPropertiesReqState } />
            </div>

          </div>

          <div className="hi-inqdetails__attachments">
            <p className="hi-inqdetails__attachments-title">
              <i className="fas fa-handshake mr-2"></i>
              Commission Agreement
            </p>

            <div className="hi-inqdetails__attachment-group">
              <div className="hi-inqdetails__attachments__row">
                <p className="hi-inqdetails__attachments__row-label">Hoppler Commission</p>
              </div>
            </div>
            <div className="hi-inqdetails__attachment-group">
              <div className="hi-inqdetails__attachments__row">
                <p className="hi-inqdetails__attachments__row-label">PHP { props.inquiry.commissionHoppler || "-" }</p>

                { showCommissionEdit &&
                  <div className="btn-group">
                    <button className="btn btn-link hi-inqdetails__attachments-action-button"
                      onClick={ () => props.onEditCommissionClick(props.inquiry) }>
                      edit
                    </button>
                  </div>
                }
                { !showCommissionEdit &&
                  <div className="btn hi-inqdetails__attachments-action-button text-muted">
                    edit
                  </div>
                }
              </div>
            </div>

            <div className="hi-inqdetails__attachment-group">
              <div className="hi-inqdetails__attachments__row">
                <p className="hi-inqdetails__attachments__row-label">Co-broker Commission</p>
              </div>
            </div>
            <div className="hi-inqdetails__attachment-group">
              <div className="hi-inqdetails__attachments__row">
                <p className="hi-inqdetails__attachments__row-label">PHP { props.inquiry.commissionCoBroker || "-" }</p>
                { showCommissionEdit &&
                  <div className="btn-group">
                    <button className="btn btn-link hi-inqdetails__attachments-action-button"
                      onClick={ () => props.onEditCommissionClick(props.inquiry) }>
                      edit
                    </button>
                  </div>
                }
                { !showCommissionEdit &&
                  <div className="btn hi-inqdetails__attachments-action-button text-muted">
                    edit
                  </div>
                }
              </div>
            </div>

          </div>

          <div className="hi-inqdetails__attachments">
            <p className="hi-inqdetails__attachments-title">
              <i className="fas fa-paperclip mr-2"></i>
              Attachments
            </p>

            <div className="hi-inqdetails__attachment-group">
              <div className="hi-inqdetails__attachments__row">
                <p className="hi-inqdetails__attachments__row-label">Viewing lists</p>
                <div className="button-group">
                  <button className="btn btn-link hi-inqdetails__attachments-action-button"
                    onClick={ () => props.onCreateVl(props.inquiry) }>
                    create new
                  </button>
                </div>
              </div>
              <InquiryDetailsVlList inquiry={ props.inquiry }
                vlMetaList={ props.viewingLists && props.viewingLists.results }
                reqState={ props.viewingListReqState }
                onEditClick={ (vlKey) => props.onEditVl(props.inquiry, vlKey) } />
            </div>

            <div className="hi-inqdetails__attachment-group">
              <div className="hi-inqdetails__attachments__row">
                <p className="hi-inqdetails__attachments__row-label">LOI</p>
                <div className="btn-group">
                  <button className="btn btn-link hi-inqdetails__attachments-action-button"
                    onClick={ () => props.onCreateLoiClick(props.inquiry) }>
                    create new
                  </button>
                  <button className="btn btn-link hi-inqdetails__attachments-action-button hi-inqdetails__attachments-action-button--upload" 
                    onClick={ () => props.onUploadOfferGenericClick(props.inquiry) }
                    disabled={ props.offers && !props.offers.count }>
                    upload
                  </button>
                </div>
              </div>
              <InquiryDetailsDocumentList documents={ props.offers && props.offers.results }
                inquiry={ props.inquiry }
                documentType={ InquiryDocumentType.OFFER }
                reqState={ props.offersReqState }
                onEditClick={ docItem => props.onEditLoiClick(props.inquiry, docItem) }
                onStatusClick={ docItem => props.onSentOfferStatusClick(props.inquiry, docItem) } />
            </div>
            

            <div className="hi-inqdetails__attachment-group">
              <div className="hi-inqdetails__attachments__row">
                <p className="hi-inqdetails__attachments__row-label">Contract</p>
                <div className="btn-group">
                  <button href="#" className="btn btn-link hi-inqdetails__attachments-action-button"
                    onClick={ () => props.onCreateContractClick(props.inquiry) }>
                    create new
                  </button>
                  <button className="btn btn-link hi-inqdetails__attachments-action-button hi-inqdetails__attachments-action-button--upload"
                    onClick={ () => props.onUploadContractClick(props.inquiry) }
                    disabled={ props.contracts && !props.contracts.count }>
                    upload
                  </button>
                </div>
              </div>
              <InquiryDetailsDocumentList documents={ props.contracts && props.contracts.results }
                inquiry={ props.inquiry }
                documentType={ InquiryDocumentType.CONTRACT }
                reqState={ props.contractsReqState }
                onEditClick={ docItem => props.onEditContractClick(props.inquiry, docItem) }
                onStatusClick={ docItem => console.log('STATUS', docItem) } />
            </div>
          </div>

          <div className="hi-inqdetails__activity">
            <div className="hi-inqdetails__activity-header">
              <p className="hi-inqdetails__activity-title">
                <i className="fas fa-comment-alt mr-2"></i>
                Comments/Activity
                { this.getCommentsSpinnerIndicator(props, state) }
              </p>

              <button
                onClick={ () => this.onShowCommentsModal() } 
                className="btn btn-link hi-inqdetails__attachments-action-button">add</button>
            </div>
            
            { this.getCommentsBlock(props, state) }

            { this.getCommentsSeeMoreButton(props, state) }
          </div>
        </div>        
      </section>
    )
  }
}
